import styled from 'styled-components';
import { Colors } from 'src/utils/color';

export const ContentView = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: ${Colors.theme.page_background};
`;

export const ResponsiveContentContainer = styled.div`
    flex: 1;
    padding: 20px;
    max-width: 1400px;
    margin: 0 auto;
    width: 100%;
    
    @media (max-width: 768px) {
        padding: 10px;
    }
`;

export const NetworkContainer = styled.div`
    margin-top: 20px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    min-height: 600px;
    
    @media (max-width: 768px) {
        padding: 15px;
        min-height: 675px; // Taller graph for tablet
        margin-top: 15px;
    }
    
    @media (max-width: 480px) {
        padding: 8px;
        min-height: 525px; // Taller graph for mobile
        margin-top: 8px;
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

export const BackButton = styled.button`
    background-color: ${Colors.theme.primary};
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    margin-bottom: 20px;
    transition: all 0.3s ease;
    
    &:hover {
        background-color: ${Colors.extra.dark_gray};
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    @media (max-width: 768px) {
        padding: 10px 20px;
        font-size: 14px;
    }
`;

export const HeaderTitle = styled.h1`
    color: ${Colors.theme.primary};
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: center;
    
    @media (max-width: 768px) {
        font-size: 1.8rem;
        margin-bottom: 8px;
    }
    
    @media (max-width: 480px) {
        font-size: 1.4rem;
        margin-bottom: 6px;
    }
`;

export const HeaderDescription = styled.p`
    color: ${Colors.theme.secondary};
    font-size: 1.2rem;
    text-align: center;
    margin-bottom: 30px;
    line-height: 1.6;
    
    @media (max-width: 768px) {
        font-size: 1rem;
        margin-bottom: 15px;
        line-height: 1.5;
    }
    
    @media (max-width: 480px) {
        font-size: 0.9rem;
        margin-bottom: 10px;
        line-height: 1.4;
    }
`;

export const GalleryHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
    padding: 20px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 768px) {
        padding: 15px;
        margin-bottom: 20px;
    }
`;

export const NetworkNode = styled.div<{ nodeType: string; isClickable?: boolean }>`
    padding: 12px 16px;
    border-radius: 8px;
    color: white;
    font-weight: 600;
    text-align: center;
    cursor: ${props => props.isClickable ? 'pointer' : 'default'};
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    background-color: ${props => {
        switch (props.nodeType) {
            case 'gene': return '#FF6B6B';
            case 'drug': return '#4ECDC4';
            case 'target': return '#96CEB4';
            case 'disease': return '#FF8C00';
            case 'imaging': return '#FFEAA7';
            default: return '#95A5A6';
        }
    }};
    
    &:hover {
        transform: ${props => props.isClickable ? 'scale(1.05)' : 'scale(1.02)'};
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    
    @media (max-width: 768px) {
        padding: 10px 12px;
        font-size: 14px;
    }
`;

export const NetworkGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
    width: 100%;
    margin-top: 20px;
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 10px;
    }
`;

export const GeneDetailsPanel = styled.div`
    margin-top: 20px;
    padding: 20px;
    background-color: white;
    border-radius: 12px;
    border: 2px solid #FF6B6B;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    
    h4 {
        color: #FF6B6B;
        margin-bottom: 15px;
        font-size: 1.3rem;
    }
    
    p {
        margin-bottom: 8px;
        color: #333;
        line-height: 1.5;
    }
    
    @media (max-width: 768px) {
        padding: 15px;
        margin-top: 15px;
    }
`;

export const PDBViewerButton = styled.button`
    padding: 10px 20px;
    background-color: #FF6B6B;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    margin-top: 15px;
    transition: all 0.3s ease;
    
    &:hover {
        background-color: #e55a5a;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    @media (max-width: 768px) {
        padding: 8px 16px;
        font-size: 14px;
    }
`;

export const PDBViewerModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    
    @media (max-width: 768px) {
        padding: 10px;
    }
`;

export const PDBViewerContent = styled.div`
    background-color: white;
    padding: 20px;
    border-radius: 12px;
    max-width: 90%;
    max-height: 90%;
    overflow: auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    
    @media (max-width: 768px) {
        padding: 15px;
        max-width: 95%;
        max-height: 95%;
    }
`;

export const PDBViewerHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #eee;
    
    h3 {
        color: #FF6B6B;
        margin: 0;
        font-size: 1.5rem;
    }
    
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        
        h3 {
            font-size: 1.3rem;
        }
    }
`;

export const PDBViewerCloseButton = styled.button`
    padding: 8px 16px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s ease;
    
    &:hover {
        background-color: #c82333;
        transform: translateY(-1px);
    }
    
    @media (max-width: 768px) {
        padding: 6px 12px;
        font-size: 14px;
    }
`;

export const PDBViewerContainer = styled.div`
    width: 800px;
    height: 600px;
    border: 1px solid #ddd;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    
    @media (max-width: 768px) {
        width: 100%;
        height: 400px;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    text-align: center;
    
    div {
        font-size: 1.2rem;
        color: ${Colors.theme.secondary};
        margin-bottom: 20px;
    }
`;

export const ErrorContainer = styled.div`
    text-align: center;
    padding: 50px;
    background-color: #f8d7da;
    color: #721c24;
    border-radius: 12px;
    border: 1px solid #f5c6cb;
    margin: 20px 0;
    
    h4 {
        margin-bottom: 15px;
        font-size: 1.3rem;
    }
    
    p {
        margin-bottom: 20px;
        line-height: 1.5;
    }
    
    button {
        padding: 10px 20px;
        background-color: #dc3545;
        color: white;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        font-weight: 600;
        transition: all 0.3s ease;
        
        &:hover {
            background-color: #c82333;
            transform: translateY(-1px);
        }
    }
    
    @media (max-width: 768px) {
        padding: 30px 20px;
        
        h4 {
            font-size: 1.1rem;
        }
        
        p {
            font-size: 14px;
        }
    }
`;

export const NetworkStats = styled.div`
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-bottom: 30px;
    flex-wrap: wrap;
    
    @media (max-width: 768px) {
        gap: 15px;
        margin-bottom: 20px;
    }
`;

export const StatItem = styled.div`
    text-align: center;
    padding: 15px 20px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    min-width: 120px;
    
    .stat-number {
        font-size: 2rem;
        font-weight: 700;
        color: ${Colors.theme.primary};
        margin-bottom: 5px;
    }
    
    .stat-label {
        font-size: 0.9rem;
        color: ${Colors.theme.secondary};
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    
    @media (max-width: 768px) {
        padding: 12px 15px;
        min-width: 100px;
        
        .stat-number {
            font-size: 1.5rem;
        }
        
        .stat-label {
            font-size: 0.8rem;
        }
    }
`;

export const SearchContainer = styled.div`
    margin-bottom: 30px;
    padding: 20px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 768px) {
        padding: 15px;
        margin-bottom: 20px;
    }
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 15px 20px;
    font-size: 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
    outline: none;
    
    &::placeholder {
        color: #6c757d;
        font-style: italic;
    }
    
    &:focus {
        border-color: ${Colors.theme.primary};
        background-color: white;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
    
    &:hover {
        border-color: #adb5bd;
        background-color: white;
    }
    
    @media (max-width: 768px) {
        padding: 12px 16px;
        font-size: 14px;
    }
`;

export const SearchButton = styled.button`
    margin-top: 15px;
    padding: 12px 24px;
    background-color: ${Colors.theme.primary};
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        background-color: ${Colors.extra.dark_gray};
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    &:disabled {
        background-color: #6c757d;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
    
    @media (max-width: 768px) {
        padding: 10px 20px;
        font-size: 14px;
    }
`;

export const SearchHelpText = styled.p`
    margin-top: 10px;
    font-size: 14px;
    color: ${Colors.theme.secondary};
    line-height: 1.5;
    
    @media (max-width: 768px) {
        font-size: 13px;
    }
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 30px;
    
    @media (max-width: 768px) {
        gap: 15px;
        margin-bottom: 20px;
    }
`;

export const UploadButton = styled.button`
    padding: 12px 24px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    
    &:hover {
        background-color: #218838;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    &:disabled {
        background-color: #6c757d;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
    
    @media (max-width: 768px) {
        padding: 10px 20px;
        font-size: 14px;
    }
`;

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    
    @media (max-width: 768px) {
        padding: 10px;
    }
`;

export const ModalContent = styled.div`
    background-color: white;
    border-radius: 12px;
    max-width: 600px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    
    @media (max-width: 768px) {
        max-width: 95%;
        max-height: 95vh;
    }
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 2px solid #eee;
    
    h3 {
        margin: 0;
        color: ${Colors.theme.primary};
        font-size: 1.5rem;
    }
    
    @media (max-width: 768px) {
        padding: 15px;
        
        h3 {
            font-size: 1.3rem;
        }
    }
`;

export const ModalCloseButton = styled.button`
    background: none;
    border: none;
    font-size: 28px;
    color: #666;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
    
    &:hover {
        background-color: #f0f0f0;
        color: #333;
    }
`;

export const UploadTabs = styled.div`
    display: flex;
    border-bottom: 2px solid #eee;
    padding: 0 20px;
    
    @media (max-width: 768px) {
        padding: 0 15px;
    }
`;

export const UploadTab = styled.button<{ active: boolean }>`
    flex: 1;
    padding: 15px 20px;
    background: none;
    border: none;
    border-bottom: 3px solid ${props => props.active ? Colors.theme.primary : 'transparent'};
    color: ${props => props.active ? Colors.theme.primary : '#666'};
    font-size: 16px;
    font-weight: ${props => props.active ? '600' : '400'};
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        color: ${Colors.theme.primary};
        background-color: #f8f9fa;
    }
    
    @media (max-width: 768px) {
        padding: 12px 15px;
        font-size: 14px;
    }
`;

export const UploadTabContent = styled.div`
    padding: 20px;
    
    @media (max-width: 768px) {
        padding: 15px;
    }
`;

export const FileUploadArea = styled.div<{ hasFile: boolean }>`
    border: 2px dashed ${props => props.hasFile ? Colors.theme.primary : '#ccc'};
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: ${props => props.hasFile ? '#f0f8ff' : '#fafafa'};
    
    &:hover {
        border-color: ${Colors.theme.primary};
        background-color: #f0f8ff;
    }
    
    p {
        margin: 0;
        color: ${props => props.hasFile ? Colors.theme.primary : '#666'};
        font-size: 16px;
        font-weight: ${props => props.hasFile ? '600' : '400'};
    }
    
    @media (max-width: 768px) {
        padding: 30px 15px;
        
        p {
            font-size: 14px;
        }
    }
`;

export const URLInput = styled.input`
    width: 100%;
    padding: 15px 20px;
    font-size: 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
    outline: none;
    
    &::placeholder {
        color: #6c757d;
        font-style: italic;
    }
    
    &:focus {
        border-color: ${Colors.theme.primary};
        background-color: white;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
    
    @media (max-width: 768px) {
        padding: 12px 16px;
        font-size: 14px;
    }
`;

export const LoginPrompt = styled.div`
    padding: 20px;
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 8px;
    text-align: center;
    color: #856404;
    
    p {
        margin: 5px 0;
    }
    
    @media (max-width: 768px) {
        padding: 15px;
        font-size: 14px;
    }
`;

export const FeatureLockedMessage = styled.div`
    margin-top: 30px;
    padding: 30px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
    
    h4 {
        color: ${Colors.theme.primary};
        margin-bottom: 10px;
    }
    
    p {
        color: ${Colors.theme.secondary};
        margin-bottom: 20px;
    }
    
    @media (max-width: 768px) {
        padding: 20px;
        
        h4 {
            font-size: 1.2rem;
        }
        
        p {
            font-size: 14px;
        }
    }
`;
